import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const BellWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const BellButton = styled.button`
  position: relative;
  width: 2.25rem;
  height: 2.25rem;
  display: grid;
  place-items: center;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  cursor: pointer;
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  svg path {
    fill: ${tokens.text.secondary};
  }

  &:hover {
    border-color: ${tokens.accent.base};

    svg path {
      fill: ${tokens.accent.base};
    }
  }
`

export const BellBadge = styled.span`
  position: absolute;
  top: -0.375rem;
  right: -0.375rem;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.25rem;
  display: grid;
  place-items: center;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.status.danger.fg};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.micro};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`

export const PanelContainer = styled.div`
  position: fixed;
  top: 4.5rem;
  right: 1.5rem;
  width: min(400px, 92vw);
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  z-index: 999999;
  border-radius: ${tokens.radius.card};
  border: 1px solid ${tokens.border.strong};
  background: ${tokens.surface.base};
  box-shadow: ${tokens.shadow.card};
  overflow: hidden;
`

export const PanelHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const PanelTitle = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.primary};
`

export const PanelAction = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.accent.base};

  &:hover {
    text-decoration: underline;
  }
`

export const PanelList = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const PanelRow = styled.button<{ $unread: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.625rem 1rem;
  border: none;
  border-bottom: 1px solid ${tokens.border.hairline};
  border-left: 2px solid ${({ $unread }) => ($unread ? tokens.accent.base : 'transparent')};
  background: ${({ $unread }) => ($unread ? tokens.surface.glass : 'transparent')};
  text-align: left;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${tokens.surface.inset};
  }
`

export const RowDot = styled.span<{ $sev: 'high' | 'med' | 'low' }>`
  flex: none;
  margin-top: 0.375rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 100%;
  background: ${({ $sev }) =>
    $sev === 'high' ? tokens.status.danger.fg : $sev === 'med' ? tokens.status.warning.fg : tokens.status.info.fg};
`

export const RowBody = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const RowTitle = styled.span<{ $unread: boolean }>`
  font-size: ${tokens.font.label};
  font-weight: ${({ $unread }) => ($unread ? 700 : 500)};
  color: ${tokens.text.primary};
`

export const RowMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const PanelFooter = styled.div`
  padding: 0.625rem 1rem;
  border-top: 1px solid ${tokens.border.hairline};
  display: flex;
  justify-content: center;
`

export const PanelEmpty = styled.div`
  padding: 1.5rem 1rem;
  text-align: center;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
